import { Home } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconHouse(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Home />
    </IconWrapper>
  );
}
